import Intercom, { update } from '@intercom/messenger-js-sdk';
import { XMark } from '@raydiant/raydial/components/Icons';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import history from '../../history';
import { selectUserProfile } from '../../selectors/user';

let showLauncherCallback: (() => void) | null = null;

export const triggerShowLauncher = () => {
  if (showLauncherCallback) showLauncherCallback();
};

const IntercomProvider = () => {
  const currentUser = useSelector(selectUserProfile);
  const [showLauncher, setShowLauncher] = useState(true);

  useEffect(() => {
    if (process.env.REACT_APP_INTERCOM_ENABLED !== 'true') return;
    showLauncherCallback = () => {
      setShowLauncher(true);
      update({ hide_default_launcher: false });
    };
    return () => {
      showLauncherCallback = null;
    };
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_INTERCOM_ENABLED !== 'true') return;

    Intercom({
      app_id: process.env.REACT_APP_INTERCOM_APP_ID!,
      alignment: 'right',
      horizontal_padding: 30,
      vertical_padding: 30,
    });

    const unlisten = history.listen(() => {
      setShowLauncher(true);
      update({ hide_default_launcher: false });
    });

    return () => {
      unlisten();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!currentUser || process.env.REACT_APP_INTERCOM_ENABLED !== 'true')
      return;

    const createdAt = Math.floor(
      new Date(currentUser.createdAt).getTime() / 1000,
    );
    update({
      user_id: currentUser.id,
      email: currentUser.email,
      name: currentUser.name,
      ...(Number.isFinite(createdAt) ? { created_at: createdAt } : {}),
    });
  }, [currentUser]);

  if (process.env.REACT_APP_INTERCOM_ENABLED !== 'true') return null;
  if (!showLauncher) return null;

  const handleClose = () => {
    setShowLauncher(false);
    update({ hide_default_launcher: true });
  };

  return (
    <button
      onClick={handleClose}
      aria-label="Close chat"
      style={{ zIndex: 2147483647 }}
      className="
        fixed
        bottom-[18px]
        right-[18px]
        md:bottom-[26px]
        md:right-[22px]
        bg-black
        text-white
        border-none
        text-[16px]
        md:text-[13px]
        px-[5px]
        py-[5.5px]
        md:px-[3px]
        md:py-[3.5px]
        rounded-full
        cursor-pointer
      "
    >
      <XMark className="md:ml-[1px]" />
    </button>
  );
};

export default IntercomProvider;
